<div class="modal-content" *ngIf="transportForm">
  <div class="modal-body text-center">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right fas fa-times"> </i>
    </div>
    <jhi-bary-icon [icon]="icon" [faDirective]="FAS" size="4x" [class]="iconClass"></jhi-bary-icon>
    <p class="lead mt-4">{{ title }}</p>
    <div class="text-left text-danger">
      <jhi-estimation-my-addresses
        [isPickup]="isPickup"
        [options]="{ withoutAddButtons: true, noShadow: true, autocomplete: false, minLengthForSearch: 0, isLightEstimate: isLightEstimate }"
        [transportForm]="transportForm"
        (selectedAddressChange)="submit()"
      ></jhi-estimation-my-addresses>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button [outline]="true" color="primary" [label]="'Annuler'" (clickEvent)="handleClick({ cancel: true })"></jhi-bary-button>
  </div>
</div>
